let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("h4k4y"), load("4waaI"), load("h7oxu"), load("2YGYU"), load("cGtlr"), load("6aruy")]).then(() => parcelRequire('9VKkC'));